import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const GripIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faGripVertical} color="#5a5c60" />;
};
